import React from 'react'
import GuestLayout from 'components/app/GuestLayout'
import Container from './Container'

export default () => (
    <GuestLayout>
        <Container />
    </GuestLayout>
)
